export const PLUGILO_EXTENSION_OPEN_SIDEBAR_FULL =
  "PLUGILO_EXTENSION_OPEN_SIDEBAR_FULL";
export const PLUGILO_EXTENSION_OPEN_SIDEBAR_FULL_CONFIRMED =
  "PLUGILO_EXTENSION_OPEN_SIDEBAR_FULL_CONFIRMED";
export const PLUGILO_EXTENSION_RELOAD = "PLUGILO_EXTENSION_RELOAD";
export const PLUGILO_EXTENSION_CLOSE_SIDEBAR =
  "PLUGILO_EXTENSION_CLOSE_SIDEBAR";
